import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import { signOut } from "@/lib/auth";
import { fetchSession, forgetSession } from "@/lib/session";

const LogoutPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      const session = await fetchSession();

      if (!session.user) {
        navigate({ to: "/" });
        return;
      }

      await signOut();
      forgetSession();
      toast.success("Logged out");
      setLoading(false);
    };

    run();
  }, [navigate]);

  return loading ? (
    <div className="min-h-[100dvh] w-full flex items-center justify-center gap-3">
      <Loader className="animate-spin" />
      <h4 className="scroll-m-20 text-lg font-medium tracking-tight">
        Loading
      </h4>
    </div>
  ) : (
    <div>You are being logged out</div>
  );
};

export const Route = createFileRoute("/logout")({
  component: LogoutPage,
});
